import {BehaviorSubject} from 'rxjs';

export abstract class DataFilterServiceBase<T> {
  loading$ = new BehaviorSubject<boolean>(false);
  dataFilter = new BehaviorSubject<T>({} as T);

  initDataFilter(filtrKey: string) {
    this.dataFilter.next(this.readFilter(filtrKey));
  }

  runFilter(filtrKey: string, filter: T) {
    this.loading$.next(true);
    this.saveFilter(filtrKey, filter);
    this.dataFilter.next(this.readFilter(filtrKey));
  }

  private getFilterKey(name: string): string {
    return `Prs-NL-${name}`;
  }

  saveFilter(name: string, filter: T) {
    if(name) {
      sessionStorage.setItem(this.getFilterKey(name), JSON.stringify(filter || {}));
    }
  }
  
  readFilter(name: string): T {
    let result = {} as T;
    if(name) {
      result = JSON.parse(sessionStorage.getItem(this.getFilterKey(name)) || '{}') as T;
    }
    return result;
  }
}
